import { atom, selector } from 'recoil'
import { keyFactory } from 'src/utils/recoil'
import { alphamapClient } from 'src/clients'

import * as mobilityAtoms from 'src/atoms/mobility'
import * as overviewAtoms from 'src/atoms/true-trade-area/overview'
import { visitsToVisitsShape } from 'src/utils/true-trade-area'
import { BoundaryType, VisitorOriginType } from 'src/common-services'
import { convertDateToString } from 'src/utils/date-utils'

const key = keyFactory('tta-change-over-time')

const defaultBoundaryType = selector<BoundaryType>({
  key: key('default-boundary-type'),
  get: ({ get }) => {
    const available = get(overviewAtoms.availableBoundaries)

    if (available.length === 0 || available.includes('cbg')) {
      return 'cbg'
    }
    return 'zipcode'
  },
})

export const boundaryType = atom<BoundaryType>({
  key: key('boundary-type'),
  default: defaultBoundaryType,
})

export const currentDate = atom<string | undefined>({
  key: key('current-date'),
  default: undefined,
})

export const visitorOrigin = atom<VisitorOriginType>({
  key: key('visitor-origin'),
  default: 'home',
})

export const playing = atom<boolean>({
  key: key('playing'),
  default: false,
})

export const locationVisitsByHomeDateRange = selector({
  key: key('location-visits-by-home-date-range'),
  get: async ({ get }) => {
    const locationId = get(mobilityAtoms.alphamapLocationId)
    if (!locationId) {
      return []
    }
    const validDateRange = get(overviewAtoms.validTTADateRange)
    const type = get(boundaryType)
    const _visitorOrigin = get(visitorOrigin)

    const res = await alphamapClient.mobility.getLocationVisitsByHomeDateRange({
      id: locationId,
      startDate: '2019-01-01',
      endDate: convertDateToString(validDateRange.end),
      type,
      visitorOrigin: _visitorOrigin,
    })
    return res
  },
})

export const currentVisits = selector({
  key: key('current-visits'),
  get: ({ get }) => {
    const date = get(currentDate)
    const visits = get(locationVisitsByHomeDateRange)
    if (!date || !visits) {
      return []
    }
    const currentVisits = visits.find((v) => v.date === date)
    if (!currentVisits) {
      return []
    }
    return currentVisits.visitorsByHome
  },
})

export const overTimeVisits = selector({
  key: key('over-time-visits'),
  get: ({ get }) => {
    const visits = get(currentVisits)
    if (!visits) {
      return []
    }
    return visitsToVisitsShape(visits)
  },
})
